import React, { createContext, Component } from "react";
import nextId from "react-id-generator";
import jwt_decode from "jwt-decode";
import {
  getAllColleges,
  getAllCourses,
  getAllSpecialization,
  getAllUniversities,
  getInstituteCount,
  getInstituteProfile,
  getJobCount,
  getProfileDetails,
  getSavedJobsId,
} from "../../../APIs/GetAPIs";

export const MainContext = createContext();
export default class ContextProvider extends Component {
  state = {
    dropdown: null,
    userDetails: null,
    userType: "",
    registrationStep: [...steps],
    jobListPage: "",
    savedJobs: [],
    appliedJobs: [],
    logOutModal: false,
    totalJobCount: 0,
    totalInstituteCount: 0,
    qualificationData: {},
    specializationData: {},
    routeLink: ""
  };
  updateState = (field, value) => {
    this.setState({ [field]: value });
  };
  getAllDropdownData = async () => {
    let apiOne = getAllSpecialization();
    let apiTwo = getAllColleges();
    let apiThree = getAllUniversities();
    let apiFour = getAllCourses();
    try {
      let res = await Promise.all([apiOne, apiTwo, apiThree, apiFour]);
      let tempOne = res[0].data.data.map((obj) => {
        return { ...obj, name: obj.specialization_name };
      });
      let tempTwo = res[1].data.data.map((obj) => {
        return { ...obj, name: obj.college_name };
      });
      let tempThree = res[2].data.data.map((obj) => {
        return { ...obj, name: obj.university_name };
      });
      let tempFour = res[3].data.data.map((obj) => {
        return { ...obj, name: obj.course_name };
      });
      let temp = {
        specializations: [
          ...tempOne,
          { _id: "other", name: "Other", id: "other" },
        ],
        colleges: [...tempTwo, { _id: "other", name: "Other", id: "other" }],
        universities: [
          ...tempThree,
          { _id: "other", name: "Other", id: "other" },
        ],
        courses: [...tempFour, { _id: "other", name: "Other", id: "other" }],
        years: years,
      };
      this.setState({ dropdown: { ...temp } });
    } catch (error) {
      let temp = {
        specializations: [],
        colleges: [],
        universities: [],
        courses: [],
      };
      this.setState("dropdown", { ...temp });
    }
  };
  setUpSavedJobArray = async () => {
    try {
      let res = await getSavedJobsId();
      if (res.data.statusCode === 200) {
        this.setState({
          savedJobs: res.data.data?.saved || [],
          appliedJobs: res.data.data?.applied || [],
        });
      } else {
      }
    } catch (error) {}
  };
  initialChecking = async () => {
    let token = localStorage.getItem("userToken");
    if (!token) {
      this.setState({ userDetails: false });

      return;
    }
    let decoded = jwt_decode(token);
    this.setState({ userType: decoded.role_type });
    try {
      let res = await (decoded.role_type === "candidate"
        ? getProfileDetails()
        : getInstituteProfile());
      if (!res.data.error) {
        if (!res.data.data) {
          this.setState({ userDetails: false });
          return;
        }
        if (decoded.role_type === "candidate") {
          if (res.data.specializationData) {
            this.setState({
              specializationData: { ...res.data.specializationData },
            });
          }

          if (res.data.qualificationData) {
            this.setState({
              qualificationData: { ...res.data.qualificationData },
            });
          }

          if (res.data.collegeData) {
            this.setState({
              collegeData: { ...res.data.collegeData },
            });
          }

          this.setState({ userDetails: res.data.data });
          this.setUpSavedJobArray();
        } else {
          this.setState({ userDetails: res.data?.data });
        }
      } else {
        this.setState({ userDetails: false });
      }
    } catch (error) {}
  };
  decryptTheToken = () => {
    let token = localStorage.getItem("userToken");
    if (!token) return;
    let decoded = jwt_decode(token);
    this.setState({ userType: decoded.role_type });
  };
  setUpTotalJobs = async () => {
    let apiOne = await getJobCount();
    let apiTwo = await getInstituteCount();
    try {
      let res = await Promise.all([apiOne, apiTwo]);
      if (res[0].data.data) {
        this.setState({ totalJobCount: res[0].data.data.total });
      }
      if (res[1].data.data) {
        this.setState({ totalInstituteCount: res[1].data.data.count });
      }
    } catch (error) {}
  };
  componentDidMount = () => {
    this.getAllDropdownData();
    this.initialChecking();
    this.setUpTotalJobs();
  };

  render() {
    return (
      <MainContext.Provider
        value={{
          ...this.state,
          updateState: this.updateState,
          initialChecking: this.initialChecking,
          setUpSavedJobArray: this.setUpSavedJobArray,
        }}
      >
        {this.props.children}
      </MainContext.Provider>
    );
  }
}
const years = [
  { _id: nextId(), name: "2020", id: "2020" },
  { _id: nextId(), name: "2019", id: "2019" },
  { _id: nextId(), name: "2018", id: "2018" },
  { _id: nextId(), name: "2017", id: "2017" },
  { _id: nextId(), name: "2016", id: "2016" },
  { _id: nextId(), name: "2015", id: "2015" },
  { _id: nextId(), name: "2014", id: "2014" },
  { _id: nextId(), name: "2013", id: "2013" },
  { _id: nextId(), name: "2012", id: "2012" },
  { _id: nextId(), name: "2011", id: "2011" },
  { _id: nextId(), name: "2010", id: "2010" },
  { _id: nextId(), name: "2009", id: "2009" },
  { _id: nextId(), name: "2008", id: "2008" },
  { _id: nextId(), name: "2007", id: "2007" },
  { _id: nextId(), name: "2006", id: "2006" },
  { _id: nextId(), name: "2005", id: "2005" },
  { _id: nextId(), name: "2004", id: "2004" },
  { _id: nextId(), name: "2003", id: "2003" },
  { _id: nextId(), name: "2002", id: "2002" },
  { _id: nextId(), name: "2001", id: "2001" },
  { _id: nextId(), name: "2000", id: "2000" },
  { _id: nextId(), name: "1999", id: "1999" },
  { _id: nextId(), name: "1998", id: "1998" },
  { _id: nextId(), name: "1997", id: "1997" },
  { _id: nextId(), name: "1996", id: "1996" },
  { _id: nextId(), name: "1995", id: "1995" },
  { _id: nextId(), name: "1994", id: "1994" },
  { _id: nextId(), name: "1993", id: "1993" },
  { _id: nextId(), name: "1992", id: "1992" },
  { _id: nextId(), name: "1991", id: "1991" },
  { _id: nextId(), name: "1990", id: "1990" },
  { _id: nextId(), name: "1999", id: "1989" },
  { _id: nextId(), name: "1998", id: "1988" },
  { _id: nextId(), name: "1997", id: "1987" },
  { _id: nextId(), name: "1996", id: "1986" },
  { _id: nextId(), name: "1995", id: "1985" },
  { _id: nextId(), name: "1994", id: "1984" },
  { _id: nextId(), name: "1993", id: "1983" },
  { _id: nextId(), name: "1992", id: "1982" },
  { _id: nextId(), name: "1991", id: "1981" },
  { _id: nextId(), name: "1990", id: "1980" },
  { _id: nextId(), name: "1999", id: "1979" },
  { _id: nextId(), name: "1998", id: "1978" },
  { _id: nextId(), name: "1997", id: "1977" },
  { _id: nextId(), name: "1996", id: "1976" },
  { _id: nextId(), name: "1995", id: "1975" },
  { _id: nextId(), name: "1994", id: "1974" },
  { _id: nextId(), name: "1993", id: "1973" },
  { _id: nextId(), name: "1992", id: "1972" },
  { _id: nextId(), name: "1991", id: "1971" },
];

const steps = [
  {
    keyId: nextId(),
    number: 1,
    title: "Personal Details",
    id: "personal",
    skipped: false,
  },
  {
    keyId: nextId(),
    number: 2,
    title: "Qualification",
    id: "qualification",
    skipped: false,
  },
  {
    keyId: nextId(),
    number: 3,
    title: "Employment",
    id: "employment",
    skipped: false,
  },
  {
    keyId: nextId(),
    number: 4,
    title: "Your Preferences",
    id: "preferences",
    skipped: false,
  },
  {
    keyId: nextId(),
    number: 5,
    title: "Your CV / Resume",
    id: "resume",
    skipped: false,
  },
];
